module.exports = "/assets/7249baa8ee43618e0cc3370fe1d2e403.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/PU.png
// module id = 2853
// module chunks = 0